﻿export class productComparerDto
{
    siteID;
    showDifferenceOnly;
    deleteExisting;
    productArticles;

    constructor(data)
    {
        this.siteID = shopConfig().currentSiteID;

        if (data)
        {
            this.showDifferenceOnly = data.showDifferenceOnly;
            this.deleteExisting = data.deleteExisting;
            this.productArticles = data.productArticles;
        }
    }
};